import React, { useState } from 'react';
import DateTimePicker from './DateTimePicker';

const WorkingTest = () => {
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    from: '',
    to: '',
    passengers: '',
    dog: false,
    disabled: false,
    returnTrip: false
  });

  const handleDateTimeChange = (date, isASAP) => {
    setSelectedDateTime(date);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Form submitted!');
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Working Taxi Booking Form</h2>
      <p>This is a simplified version that works without problematic dependencies.</p>
      
      <form onSubmit={handleSubmit} style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '8px', margin: '20px 0' }}>
        <h4>Your Taxi Fare</h4>
        
        <div style={{ marginBottom: '20px' }}>
          <DateTimePicker
            value={selectedDateTime}
            onChange={handleDateTimeChange}
            label="Date & Time"
            className="mb-3"
            use24Hour={false}
            show24HourToggle={false}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            required
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            required
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Phone:</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            required
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>From:</label>
          <input
            type="text"
            name="from"
            value={formData.from}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            required
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>To:</label>
          <input
            type="text"
            name="to"
            value={formData.to}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            required
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Passengers:</label>
          <input
            type="number"
            name="passengers"
            value={formData.passengers}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            min="1"
            max="20"
            required
            placeholder="Enter number of passengers"
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              name="dog"
              checked={formData.dog}
              onChange={handleChange}
            />
            Dog/Pet
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              name="disabled"
              checked={formData.disabled}
              onChange={handleChange}
            />
            Disabled Access
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              name="returnTrip"
              checked={formData.returnTrip}
              onChange={handleChange}
            />
            Return Trip
          </label>
        </div>

        <button
          type="submit"
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Request Taxi
        </button>
      </form>

      <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '6px', marginTop: '20px' }}>
        <h6>Selected DateTime:</h6>
        <p>{selectedDateTime.toLocaleString()}</p>
        <h6>Form Data:</h6>
        <pre style={{ fontSize: '12px', overflow: 'auto' }}>
          {JSON.stringify({ ...formData, dateTime: selectedDateTime.toISOString() }, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default WorkingTest; 